// Property types in the words renters use in Benin. The keys match TYPE_FILTERS in
// backend/Hokue/listings/views.py.
export const TYPE_OPTIONS = [
  ['ec', 'Entrée couchée'],
  ['cs1', 'Chambre salon'],
  ['cs2', '2 chambres salon'],
  ['cs3', '3 chambres salon'],
  ['cs4', '4+ chambres salon'],
  ['villa', 'Villa / maison'],
  ['shop', 'Boutique / bureau'],
];

export const BUDGET_OPTIONS = [25000, 50000, 75000, 100000, 150000, 250000, 500000];

export const PLATFORM_LABEL = { tiktok: 'TikTok', facebook: 'Facebook' };

const UNITS = ['appartement', 'entree_personnelle', 'chambre_salon'];

export function typeLabel(l) {
  const n = l.bedrooms;
  if (UNITS.includes(l.property_type) && n) {
    const base = n === 1 ? 'Chambre salon' : `${n} chambres salon`;
    return l.property_type === 'entree_personnelle' ? `${base} · entrée perso` : base;
  }
  const ch = n ? ` · ${n} chambre${n > 1 ? 's' : ''}` : '';
  switch (l.property_type) {
    case 'entree_couchee': return 'Entrée couchée';
    case 'chambre_salon': return 'Chambre salon';
    case 'appartement': return 'Appartement';
    case 'entree_personnelle': return 'Entrée personnelle';
    case 'villa_duplex': return 'Villa / duplex' + ch;
    case 'maison': return 'Maison' + ch;
    case 'boutique_bureau': return 'Boutique / bureau';
    case 'parcelle': return 'Parcelle';
    default: return null;
  }
}

export const formatFcfa = (v) => v.toLocaleString('fr-FR') + ' F';

export function priceLabel(l) {
  if (!l.price_fcfa) return null;
  if (l.price_unit === 'month') return `${formatFcfa(l.price_fcfa)} / mois`;
  if (l.price_unit === 'night') return `${formatFcfa(l.price_fcfa)} / nuit`;
  return formatFcfa(l.price_fcfa);
}

export function postedAgo(iso) {
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (days <= 0) return "Aujourd'hui";
  if (days === 1) return 'Hier';
  return `Il y a ${days} jours`;
}
